import { Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearProvidersResponses, getProvidersResponses, resendProvidersResponses, updateProvidersResponses } from "../../../../actions/connectivityResponse";
import snackbarUtils from "../../../../utils/snackbarUtils";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import { StyledNovedades } from "../../../styled/novedades";
import ProvidersResponseSearch from "./providersResponseSearch";
import ProvidersResponseTable from "./providersResponseTable";

const ProvidersResponseContainer = () => {
    const dispatch = useDispatch();

    const providersResponses = useSelector((state) => state.connectivityResponse.providersResponses);
    const [rowSelection, setRowSelection] = useState({});
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [wriId, setWriId] = useState();

    const loading = providersResponses.isFetching;

    const selectedRowsLength = Object.keys(rowSelection).length;

    const handleSearch = (values) => {
        setRowSelection({});
        setWriId(values.art);
        dispatch(getProvidersResponses(
            values.art,
            values.dni || null,
            values.siniestro || null,
            values.fechaDesde || null,
            values.fechaHasta || null
        ));
    };

    const handleClear = () => {
        dispatch(clearProvidersResponses());
        setRowSelection({});
    };

    const handleOpenConfirmDialog = () => {
        setOpenConfirmDialog(true);
    };

    const handleSubmitSelected = () => {
        const selectedIds = Object.keys(rowSelection);

        if (selectedIds.length === 0) return;

        dispatch(resendProvidersResponses(wriId, selectedIds))
            .then((res) => {
                dispatch(updateProvidersResponses(selectedIds));
                snackbarUtils.success(`Se han reenviado ${selectedIds.length} respuesta${selectedIds.length === 1 ? '' : 's'} correctamente.`);
            })
            .finally(() => {
                setRowSelection({});
            });
        setOpenConfirmDialog(false);
    };

    const handleCloseConfirmDialog = () => setOpenConfirmDialog(false);

    return (
        <StyledNovedades.Container>
            <Typography variant="h5" sx={{ padding: 2 }}>
                Respuestas Prestadores
            </Typography>
            <ProvidersResponseSearch
                isSearching={providersResponses.isFetching}
                handleSearch={handleSearch}
                handleClear={handleClear}
            />
            <ProvidersResponseTable
                handleOpenConfirmDialog={handleOpenConfirmDialog}
                data={providersResponses.data}
                loading={loading}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
            />
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={handleCloseConfirmDialog}
                handleConfirm={handleSubmitSelected}
                title={`¿Está seguro que desea reenviar ${selectedRowsLength} respuesta${selectedRowsLength === 1 ? '' : 's'} seleccionada${selectedRowsLength === 1 ? '' : 's'}?`}
            />
        </StyledNovedades.Container>
    );
};

export default ProvidersResponseContainer;
